import axios from "axios";

export function deleteQrcode(qrcodeId, type) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/${type}/qrcode/${qrcodeId}`,
    data: {
    }
  };
  return axios(config);
}
